"use client";
import { Button } from "@/components/ui/button";
import TrendingUpIcon from "@heroicons/react/24/solid/ArrowTrendingUpIcon";
import ChatBubbleLeftRightIcon from "@heroicons/react/24/solid/ChatBubbleLeftRightIcon";
import StarIcon from "@heroicons/react/24/solid/StarIcon";
import { useSite } from "@/lib/hooks/site";
import { useState } from "react";
import VenueCardNoImg from "@/components/views/list/card/VenueCardNoImg";
import S3Image from "@/components/S3Image";
import { useTranslation } from "@/hooks/translationContext";

export default function BeInTop() {
  const { t } = useTranslation()
  const site = useSite();
  const [error, setError] = useState(false);

  const fourthPhoto = site.setting?.design?.addVenue?.hero?.fourthPhoto?.["1"]

  return (
    <div className="w-full py-[40px] bg-gray-secondary flex justify-center">
      <div className="container flex gap-6 lg:flex-row flex-col items-center">
        <div className="flex flex-col lg:h-[508px] max-lg:gap-6 justify-between">
          <div className="flex flex-col gap-6">
            <h2 className="text-primary font-bold text-2xl lg:text-[32px]">
              {t("add-venue-page-sixth-section-title", {
                defaultValue: `${site.domain}’da rakiplerinizin yakaladığı iş fırsatlarını siz de görün!`
              })}
            </h2>

            <p className="text-assistant text-sm lg:text-base text-left font-bold">
              {t("add-venue-page-sixth-section-title", {
                defaultValue: `Google’da ${site.descriptions[0]?.title} ile ilgili aramalarda
              ${site.domain} en üstlerde yer alıyor ve ziyaretçiler bu sayede
              işletmelerinize ve kampanyalarınıza kolayca erişebiliyor.`
              })}
            </p>

            <div className="flex flex-wrap gap-4">
              <div className="shadow text-assistant rounded-full bg-white py-1.5 px-2 flex gap-2 items-center font-medium text-xs">
                <StarIcon className="size-6 text-secondary" />

                <h3>Semtinizin yıldızı olun</h3>
              </div>

              <div className="shadow text-assistant rounded-full bg-white py-1.5 px-2 flex gap-2 items-center font-medium text-xs">
                <TrendingUpIcon className="size-6 text-secondary" />

                <h3>En üste çıkın!</h3>
              </div>

              <div className="shadow text-assistant rounded-full bg-white py-1.5 px-2 flex gap-2 items-center font-medium text-xs">
                <ChatBubbleLeftRightIcon className="size-6 text-secondary" />

                <h3>Müşterilerinizle iletişime geçin</h3>
              </div>
            </div>
          </div>

          <Button
            onClick={() => {
              window.scrollTo({
                top: 0,
              });
            }}
            className="bg-[#15BBAE] w-[143px] hover:bg-[#15BBAE] flex"
          >
            {t("venue-add-title")}
          </Button>
        </div>
        {!fourthPhoto || error ? (
          <div className="h-full max-md:h-[377px] w-[366px] md:w-[506px]">
            <VenueCardNoImg type={0} />
          </div>
        ) : (
          <S3Image
            width={0}
            height={0}
            src={`site/${site.id}/assets/${fourthPhoto}`}
            sizes="(max-width: 600px) 366px,
                   506px"
            className="rounded-[24px] h-full max-md:h-[377px] w-[366px] md:w-[506px] object-cover object-center"
            alt={`${site.descriptions[0]?.title} ~ ${t("venue-add-title", { defaultValue: "Mekan Ekle" })}`}
            onError={() => {
              setError(true);
            }}
          />
        )}
      </div>
    </div>
  );
}
